export const LOAD_NOTIFICATIONS_$ = "LOAD_NOTIFICATIONS_$";

export const NOTIFICATIONS_LOADED = "NOTIFICATIONS_LOADED";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";
export const REDUCE_UNREAD_COUNT = "REDUCE_UNREAD_COUNT";
